import ShopRoundedIcon from '@mui/icons-material/ShopRounded';
import PermMediaRounded from '@mui/icons-material/PermMediaRounded';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import AddToQueueRoundedIcon from '@mui/icons-material/AddToQueueRounded';
import SlideshowRoundedIcon from '@mui/icons-material/SlideshowRounded';

import {
  INNENDIENDST_AND_IT_GROUP,
  LS_USER_GROUPS,
  MARKETING_AND_IT_GROUP,
  SALES_AND_IT_GROUP,
} from 'constants/user';
import { ROUTES } from 'constants/routes';

export const TOOLS_LINKS = {
  campaigns: {
    to: ROUTES.campaigns,
    Icon: ShopRoundedIcon,
    text: 'campaigns.title',
    allowedGroups: SALES_AND_IT_GROUP,
  },
  campaignCreate: {
    to: ROUTES.campaignCreate,
    Icon: AddToQueueRoundedIcon,
    text: 'campaign.titleNew',
    allowedGroups: INNENDIENDST_AND_IT_GROUP,
  },
  bookingsProblematic: {
    to: ROUTES.bookingsProblematic,
    Icon: ShopRoundedIcon,
    text: 'booking.title',
    allowedGroups: INNENDIENDST_AND_IT_GROUP,
  },
  campaignEdit: {
    to: ROUTES.campaignCreate,
    Icon: AddToQueueRoundedIcon,
    text: 'campaign.titleEdit',
    hidden: true,
    allowedGroups: SALES_AND_IT_GROUP,
  },
  media: {
    to: ROUTES.media,
    Icon: PermMediaRounded,
    text: 'media.title',
    allowedGroups: SALES_AND_IT_GROUP,
  },
  generatedMedia: {
    to: ROUTES.generatedMedia,
    Icon: PermMediaRounded,
    text: 'generatedMedia.title',
    allowedGroups: MARKETING_AND_IT_GROUP,
  },
  campaignMediaUpload: {
    to: ROUTES.campaignMediaUpload,
    Icon: PermMediaRounded,
    text: 'media.labels.campaignUpload',
    hidden: true,
  },
  upload: {
    to: ROUTES.upload,
    Icon: CloudUploadRoundedIcon,
    text: 'upload.title',
    allowedGroups: LS_USER_GROUPS,
  },
  slides: {
    to: ROUTES.slides,
    Icon: SlideshowRoundedIcon,
    text: 'slides.title',
    hidden: true,
    allowedGroups: SALES_AND_IT_GROUP,
  },
};
